export default __webpack_public_path__ + "113d513c06c56106620f956d7ed9dde8.png";